import * as React from 'react';

type Props = {
  scrollableElementSelector: string,
  elementToScrollSelector: string
};

const Scroller = ({
  scrollableElementSelector,
  elementToScrollSelector
}: Props) => {
  const ref = React.createRef<HTMLDivElement>();
  // In case of weird browser
  const requestAnimationFrame =
    window.requestAnimationFrame
    || ((handler: () => void) => setTimeout(handler, 200));

  React.useEffect(() => {
    requestAnimationFrame(() => {
      if (!ref.current) {
        return;
      }

      const div = ref.current;
      const doc = div.ownerDocument;
      const wrapper = doc.querySelector(scrollableElementSelector);
      const activeLink = doc.querySelector(elementToScrollSelector);

      if (!wrapper || !activeLink) {
        return;
      }

      // Flush to be able start from initial point.
      wrapper.scrollTop = 0;

      const someRandomPadding = 40;
      const wrapperTop = wrapper.getBoundingClientRect().top ?? 0;
      const activeLinkTop = activeLink.getBoundingClientRect().top ?? 0;
      const scrollTo = activeLinkTop - wrapperTop - someRandomPadding;

      wrapper.scrollTop = scrollTo > 0 ? scrollTo : 0;
    });
  });

  return <div ref={ref} />;
};

export default Scroller;
